var validateDate = _ref => {
  var {
    expiryOffset,
    inputValue,
    isExpiry,
    isIssueDate,
    issueOffset
  } = _ref;
  var inputYear = Number("20".concat(inputValue.substr(2)));
  var inputMonth = Number(inputValue.substr(0, 2));
  var now = new Date();
  var currentMonth = now.getMonth() + 1;
  var currentYear = now.getFullYear();
  var isCurrentYear = currentYear === inputYear;
  var isMonthLaterThisYear = isCurrentYear && inputMonth > currentMonth;
  var isMonthEarlierThisYear = isCurrentYear && inputMonth < currentMonth;
  var isMaxExpiryYear = currentYear + expiryOffset === inputYear;
  var isMinIssueYear = currentYear - issueOffset === inputYear;
  var isInvalidMonth = isExpiry && isMonthEarlierThisYear || isIssueDate && isMonthLaterThisYear || inputMonth > 12 || inputMonth < 1;
  var isInvalidYear = inputYear < currentYear - issueOffset || inputYear > currentYear + expiryOffset;
  var isInvalidCombo = isExpiry && isMaxExpiryYear && inputMonth > currentMonth || isIssueDate && isMinIssueYear && inputMonth < currentMonth;
  return {
    isInvalidCombo,
    isInvalidDate: isInvalidCombo || isInvalidMonth || isInvalidYear,
    isInvalidMonth,
    isInvalidYear
  };
};

var getValidationFn = cardDateType => {
  var FUTURE_YEAR_OFFSET = cardDateType === 'expiry' ? 15 : 0;
  var PAST_YEAR_OFFSET = cardDateType === 'issue' ? 10 : 0;
  return (inputValue, _ref2) => {
    var {
      props
    } = _ref2;
    var {
      isInvalidDate
    } = validateDate({
      expiryOffset: FUTURE_YEAR_OFFSET,
      inputValue,
      isExpiry: Boolean(FUTURE_YEAR_OFFSET),
      isIssueDate: Boolean(PAST_YEAR_OFFSET),
      issueOffset: PAST_YEAR_OFFSET
    });
    var isPresent = Boolean(inputValue.length);
    var result = {
      invalidDate: isPresent && isInvalidDate,
      invalidFormat: isPresent && !/^\d+$/.test(inputValue),
      tooLong: inputValue.length > 4,
      tooShort: isPresent && inputValue.length < 4,
      valueMissing: !isPresent
    };
    result.errors = Object.keys(result).filter(key => result[key]);
    result.isValid = result.valueMissing && !props.required || !result.errors.length;
    return result;
  };
};

var validateCardExpiry = getValidationFn('expiry');
var validateCardIssueDate = getValidationFn('issue');
export { validateCardExpiry, validateCardIssueDate };